import React from 'react';

function SimpleSynonyms({ items }) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <svg 
          className="w-5 h-5 text-green-600" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M13 10V3L4 14h7v7l9-11h-7z" 
          />
        </svg>
        <h3 className="text-lg font-semibold text-green-800">
          Simple Synonyms
        </h3>
        <span className="text-xs bg-green-200 text-green-800 px-2 py-1 rounded-full">
          Easy to understand
        </span>
      </div>
      
      <p className="text-sm text-green-700 mb-4">
        Common, everyday words that directly represent the intersection of your concepts
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((item, index) => (
          <div
            key={index}
            className="bg-white border border-green-300 rounded-lg p-3 hover:shadow-md transition-shadow"
          >
            <div className="flex justify-between items-start mb-2">
              <h4 className="font-medium text-green-900 text-lg">
                {item.word}
              </h4>
              <span className="text-sm font-semibold text-green-600 bg-green-100 px-2 py-1 rounded">
                {item.score}
              </span>
            </div>
            
            <p className="text-sm text-gray-600 mb-2">
              {item.reason}
            </p>
            
            {item.tags && (
              <div className="flex flex-wrap gap-1">
                {item.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SimpleSynonyms;
